module.exports = __webpack_public_path__ + "img/iphone-frame.fa5de647.png";